import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LitbuySpreadsheet from "../pages/litbuy-spreadsheet/page";
import WhatIsLitbuy from "../pages/guides/what-is-litbuy-spreadsheet/page";
import HowToUseLitbuy from "../pages/guides/how-to-use-litbuy-spreadsheet/page";
import BeginnerGuide from "../pages/guides/litbuy-beginner-guide/page";
import VsGoogleSheets from "../pages/comparisons/litbuy-vs-google-sheets/page";
import VsExcel from "../pages/comparisons/litbuy-vs-excel/page";
import LitbuyFeatures from "../pages/guides/litbuy-spreadsheet-features/page";
import LitbuyTemplates from "../pages/guides/litbuy-spreadsheet-templates/page";
import LitbuyTips from "../pages/guides/litbuy-spreadsheet-tips/page";
import LitbuyMistakes from "../pages/guides/litbuy-spreadsheet-mistakes/page";
import LitbuySafety from "../pages/guides/litbuy-spreadsheet-safety/page";
import LitbuyPricing from "../pages/guides/litbuy-spreadsheet-pricing/page";
import LitbuyAlternatives from "../pages/guides/litbuy-spreadsheet-alternatives/page";
import LitbuyAdvanced from "../pages/guides/litbuy-spreadsheet-advanced/page";
import LitbuyFaq from "../pages/guides/litbuy-spreadsheet-faq/page";
import Safety from "../pages/safety/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Disclaimer from "../pages/disclaimer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/litbuy-spreadsheet",
    element: <LitbuySpreadsheet />,
  },
  {
    path: "/guides/what-is-litbuy-spreadsheet",
    element: <WhatIsLitbuy />,
  },
  {
    path: "/guides/how-to-use-litbuy-spreadsheet",
    element: <HowToUseLitbuy />,
  },
  {
    path: "/guides/litbuy-beginner-guide",
    element: <BeginnerGuide />,
  },
  {
    path: "/guides/litbuy-spreadsheet-features",
    element: <LitbuyFeatures />,
  },
  {
    path: "/guides/litbuy-spreadsheet-templates",
    element: <LitbuyTemplates />,
  },
  {
    path: "/guides/litbuy-spreadsheet-tips",
    element: <LitbuyTips />,
  },
  {
    path: "/guides/litbuy-spreadsheet-mistakes",
    element: <LitbuyMistakes />,
  },
  {
    path: "/guides/litbuy-spreadsheet-safety",
    element: <LitbuySafety />,
  },
  {
    path: "/guides/litbuy-spreadsheet-pricing",
    element: <LitbuyPricing />,
  },
  {
    path: "/guides/litbuy-spreadsheet-alternatives",
    element: <LitbuyAlternatives />,
  },
  {
    path: "/guides/litbuy-spreadsheet-advanced",
    element: <LitbuyAdvanced />,
  },
  {
    path: "/guides/litbuy-spreadsheet-faq",
    element: <LitbuyFaq />,
  },
  {
    path: "/comparisons/litbuy-vs-google-sheets",
    element: <VsGoogleSheets />,
  },
  {
    path: "/comparisons/litbuy-vs-excel",
    element: <VsExcel />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;